import { urlConfig } from "../../config/urlConfig";
import { getCall, postCall } from "../httpService";
import { UserGridPreferenceModel } from "../../types/UserGridPreferenceModel";

const userGridPreferenceSave = urlConfig.UserGridPreferenceSave; // Save the UserGridPreferenceSave endpoint from urlConfig
const userGridPreferenceGet = urlConfig.UserGridPreferenceGet; // Get the UserGridPreferenceGet endpoint from urlConfig

export const saveUserGridPreference = async (
  params: UserGridPreferenceModel
) => {
  try {
    const response = await postCall(userGridPreferenceSave, params);
    return response.data;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};

export const getUserGridPreference = async (
  params: UserGridPreferenceModel
) => {
  try {
    const urlParams = {
      userId: params.UserID,
      businessUnitId: params.BusinessUnitID,
      area: params.Area,
      contextName: params.ContextName,
    };
    const response = await getCall(userGridPreferenceGet, JSON.stringify(urlParams));
    return response;
  } catch (error) {
    console.error("Error fetching data", error);
    throw error;
  }
};
